import { render, staticRenderFns } from "./SubjectTemplates.vue?vue&type=template&id=66f6e0d2"
import script from "./SubjectTemplates.vue?vue&type=script&lang=js"
export * from "./SubjectTemplates.vue?vue&type=script&lang=js"
import style0 from "./SubjectTemplates.vue?vue&type=style&index=0&id=66f6e0d2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports